<script>
import * as d3 from 'd3';
import { OrgChart } from 'd3-org-chart';

export default {
  props: {
    data: {
      default: null,
    },
  },
  data() {
    return {
      chart: null,
      themeObserver: null,
    };
  },
  watch: {
    data(value) {
      this.renderChart(value);
    },
  },
  computed: {
    svgHeight: function () {
      var height = window.innerHeight;
      return height - 310;
    }
  },
  methods: {
    getNetworkChartColors() {
      const el = document.getElementById('matriz');
      if (!el) {
        return {
          nodeBg: '#ffffff',
          nodeText: '#212529',
          linkStroke: '#555555',
          linkStrokeHighlight: '#007bff',
        };
      }
      const s = getComputedStyle(el);
      const pick = (name, fallback) => {
        const v = s.getPropertyValue(name).trim();
        return v || fallback;
      };
      return {
        nodeBg: pick('--network-node-bg', '#ffffff'),
        nodeText: pick('--network-node-text', '#212529'),
        linkStroke: pick('--network-link-stroke', '#555555'),
        linkStrokeHighlight: pick('--network-link-stroke-highlight', '#007bff'),
      };
    },
    renderChart(data) {
      if (!data) {
        return;
      }
      const colors = this.getNetworkChartColors();
      this.chart = new OrgChart();
      this.chart
        .compact(false)
        .nodeWidth(() => 200)
        .nodeHeight(() => 50)
        .childrenMargin(() => 150)
        .setActiveNodeCentered(true)
        .container('#matriz')
        .svgHeight(this.svgHeight)
        .buttonContent(({
          node
        }) => {
          return `<div style="
              display: flex;
              gap: 5px;
              align-items: center;
              justify-content: center;
              border-radius: 3px;
              padding: 5px 10px 6px;
              font-size: 10px;
              color: #fff;
              margin: auto auto;
              background-color: #333;
              text-align: center;
            ">${node.children ? `<i class="fas fa-chevron-up"></i>` : `<i class="fas fa-chevron-down"></i>`}
            <span style="display: flex; gap: 5px; align-items: center; justify-content: center;">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);transform: ;msFilter:;"><path d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"></path></svg>
              <span>${node.data._directSubordinates}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);transform: ;msFilter:;"><path d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"></path></svg>
              <span>${node.data._totalSubordinates}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);transform: ;msFilter:;"><path d="m17,13c-1.1,0-2-.9-2-2v-.36c0-.47.15-.91.43-1.23.91-1.07,1.26-2.49.96-3.88-.35-1.66-1.7-3.03-3.35-3.4-1.37-.31-2.77,0-3.85.86s-1.7,2.14-1.7,3.52c0,1.08.39,2.12,1.1,2.94.26.3.4.73.4,1.2v.36c0,1.1-.9,2-2,2-2.21,0-4,1.79-4,4v1c0,.55.45,1,1,1h16c.55,0,1-.45,1-1v-1c0-2.21-1.79-4-4-4Zm-12,4c0-1.1.9-2,2-2,2.21,0,4-1.79,4-4v-.36c0-.96-.32-1.85-.89-2.51-.39-.45-.61-1.03-.61-1.63,0-.76.34-1.48.94-1.96.61-.49,1.38-.65,2.16-.48.9.21,1.64.96,1.84,1.87.17.8-.02,1.57-.53,2.17-.59.69-.91,1.59-.91,2.53v.36c0,2.21,1.79,4,4,4,1.1,0,2,.9,2,2H5Z"></path><path d="M3 20H21V22H3z"></path></svg>
              <span>${node.data.limpanome}</span>
            </span>
          </div>`;
        })
        .nodeButtonWidth(() => 170)
        .nodeButtonX(() => -85)
        .linkUpdate(function (d) {
          d3.select(this)
            .attr('stroke', () =>
              d.data._upToTheRootHighlighted
                ? colors.linkStrokeHighlight
                : colors.linkStroke
            )
            .attr('stroke-width', () =>
              d.data._upToTheRootHighlighted ? 15 : 3
            );
        })
        .nodeContent((d) => {
          const hasChildren = d.children || d._children;

          return `
            <div style="
              background-color: ${colors.nodeBg};
              color: ${colors.nodeText};
              border: 3px solid #${d.data.color};
              border-radius: 1000px;
              width: 200px;
              height: 50px;
              font-size: 13px;
              font-weight: bold;
              text-overflow: ellipsis;
              white-space: nowrap;
            ">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  width: 200px;
                  height: 40px;
                "
              >
              <span
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100%;
                  text-align: center;
                  color: ${colors.nodeText};
                "
              >${d.data.username}</span>

              ${!hasChildren
              ? `<div style="
                position: absolute;
                bottom: -16px;
                display: flex;
                gap: 5px;
                align-items: center;
                justify-content: center;
                border-radius: 3px;
                padding: 5px 10px 6px;
                font-size: 10px;
                color: #fff;
                background-color: #333;
                text-align: center;
                height: 25px;
              ">
                <span style="display: flex; gap: 5px; align-items: center; justify-content: center;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);transform: ;msFilter:;"><path d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"></path></svg>
                  <span>${d.data._directSubordinates}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);transform: ;msFilter:;"><path d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"></path></svg>
                  <span>${d.data._totalSubordinates}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);transform: ;msFilter:;"><path d="m17,13c-1.1,0-2-.9-2-2v-.36c0-.47.15-.91.43-1.23.91-1.07,1.26-2.49.96-3.88-.35-1.66-1.7-3.03-3.35-3.4-1.37-.31-2.77,0-3.85.86s-1.7,2.14-1.7,3.52c0,1.08.39,2.12,1.1,2.94.26.3.4.73.4,1.2v.36c0,1.1-.9,2-2,2-2.21,0-4,1.79-4,4v1c0,.55.45,1,1,1h16c.55,0,1-.45,1-1v-1c0-2.21-1.79-4-4-4Zm-12,4c0-1.1.9-2,2-2,2.21,0,4-1.79,4-4v-.36c0-.96-.32-1.85-.89-2.51-.39-.45-.61-1.03-.61-1.63,0-.76.34-1.48.94-1.96.61-.49,1.38-.65,2.16-.48.9.21,1.64.96,1.84,1.87.17.8-.02,1.57-.53,2.17-.59.69-.91,1.59-.91,2.53v.36c0,2.21,1.79,4,4,4,1.1,0,2,.9,2,2H5Z"></path><path d="M3 20H21V22H3z"></path></svg>
                  <span>${d.data.limpanome}</span>
                </span>
              </div>` : ''}
              </div>
            </div>
          `;
        })

        .data(data)
        .render();
    },
  },
  mounted() {
    this.themeObserver = new MutationObserver(() => {
      if (this.data) {
        this.renderChart(this.data);
      }
    });
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-app-theme'],
    });
  },
  beforeDestroy() {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
      this.themeObserver = null;
    }
  },
};
</script>

<template>
  <div id="matriz" class="network-matriz-root">
    <div class="text-center pt-3">
      <button class="btn btn-default btn-sm ml-1" v-on:click="chart.zoomOut()"><i class="bx bx-minus-circle align-middle font-size-20"></i></button>
      <button class="btn btn-default btn-sm ml-1" v-on:click="chart.zoomIn()"><i class="bx bx-plus-circle align-middle font-size-20"></i></button>
      <button class="btn btn-default btn-sm ml-1" v-on:click="chart.fit().render()"><i class="bx bx-align-middle align-middle font-size-20"></i></button>
      <button class="btn btn-default btn-sm ml-1" v-on:click="chart.expandAll().fit()"><i class="bx bx-expand align-middle font-size-20"></i></button>
      <button class="btn btn-default btn-sm ml-1" v-on:click="chart.collapseAll().fit()"><i class="bx bx-collapse align-middle font-size-20"></i></button>
      <button class="btn btn-default btn-sm ml-1" v-on:click="chart.fullscreen()"><i class="bx bx-fullscreen align-middle font-size-20"></i></button>
    </div>
  </div>
</template>

<style scoped>
.btn {
  padding: 8px 12px;
}
</style>